import { createRouter, createWebHistory } from 'vue-router';
import Splash from '../views/Splash.vue';
import CardVerify from '../views/CardVerify.vue';
import PackageSelect from '../views/PackageSelect.vue';
import ShipInfo from '../views/ShipInfo.vue';
import Confirm from '../views/Confirm.vue';
import Logistics from '../views/Logistics.vue';
import AdminLogin from '../views/admin/Login.vue';
import AdminLayout from '../views/admin/AdminLayout.vue';
import Dashboard from '../views/admin/Dashboard.vue';
import CardManage from '../views/admin/CardManage.vue';
import AdminChat from '../views/admin/Chat.vue';
import AdminSettings from '../views/admin/Settings.vue';
import SiteAssets from '../views/admin/SiteAssets.vue';

const routes = [
  { path: '/', name: 'Splash', component: Splash },
  { path: '/verify', name: 'CardVerify', component: CardVerify },
  { path: '/package', name: 'PackageSelect', component: PackageSelect },
  { path: '/ship', name: 'ShipInfo', component: ShipInfo },
  { path: '/confirm', name: 'Confirm', component: Confirm },
  { path: '/logistics', name: 'Logistics', component: Logistics },
  { path: '/admin/login', name: 'AdminLogin', component: AdminLogin },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: 'Dashboard', component: Dashboard },
      { path: 'cards', name: 'CardManage', component: CardManage },
      { path: 'chat', name: 'AdminChat', component: AdminChat },
      { path: 'settings', name: 'AdminSettings', component: AdminSettings },
      { path: 'assets', name: 'SiteAssets', component: SiteAssets },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (!sessionStorage.getItem('adminToken')) {
      next('/admin/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
